import { render, staticRenderFns } from "./leaveUntreatedOrderDetail.vue?vue&type=template&id=75d81c01&"
import script from "./leaveUntreatedOrderDetail.vue?vue&type=script&lang=js&"
export * from "./leaveUntreatedOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports